<template>
    <div>
        
        <!--<ActualizarEmpresas :tipoBd="'CONTA'" />-->
        <!--<CRow>
            <CCol>
                <CButton
                    class="btnPrincipalVapp mb-1"
                    style="width:auto"
                    variant="ghost"
                    size="sm"
                    color="success"
                    @click="actualizar"
                    :disabled="isActualizandoEmpresas">
                    <CIcon :content="$options.freeSet.cilLoopCircular" :class="classActualizar" /> {{textoBtnActualizarEmpresas}}
                </CButton>
                
                <CButton
                    class="btnPrincipalVapp mb-1"
                    style="width:auto"
                    size="sm"
                    color="danger"
                    @click="cancelarActualizarEmpresas"
                    v-show="isActualizandoEmpresas"
                    v-c-tooltip.hover="{content:'Cancelar Actualización', placement:'right'}">
                    <CIcon :content="$options.freeSet.cilXCircle" /> Detener Actualización
                </CButton>
            </CCol>
        </CRow>-->
                        
        <CRow>
            <CCol>
                <CCard class="tarjetaGesto">
                    <CCardHeader>
                        <h4>Estado Resultado</h4>
                    </CCardHeader>
                    
                    <CCardBody>
                        <CRow><!--switch select ulti periodo-->
                            <CCol md="4">
                                <CSwitch
                                    width="150px"
                                    class="mx-1 align-middle mb-2 switchGesto"
                                    shape="pill"
                                    variant="outline"
                                    :checked="selectPeriodoActual"
                                    @update:checked="seleccionarPeriodoActual()"
                                /> Seleccionar último período
                            </CCol>
                            <CCol md="4" v-show="estadoResultado.length>0">
                                Ocultar valores en Ceros
                                <CSwitch
                                    width="150px"
                                    class="mx-1 align-middle mb-2 switchGesto"
                                    shape="pill"
                                    variant="outline"
                                    v-bind="{labelOn: '\u2713',labelOff: '\u2715'}"
                                    :checked="ocultarCeros"
                                    @update:checked="ocultarCerosProcesar"
                                />
                            </CCol>
                        </CRow>
                        <CRow>
                            <CCol sm="12" md="2" lg="2">
                                <multiselect
                                    class="mb-2 d-inline-block multSelectGesto"
                                    :custom-label="customLabelEmp"
                                    v-model="empSelected"
                                    selectedLabel=""
                                    deselectLabel=""
                                    selectLabel=""
                                    placeholder="Seleccionar Empresa" 
                                    label="nombreEmpresa" 
                                    track-by="codEmpresa" 
                                    :options="empresasInfo" 
                                    :multiple="false"
                                    @select="seleccionarEmpresa"></multiselect>
                            </CCol>
                            <CCol md="2">
                                
                                <date-picker
                                    style="width: 100%"
                                    class="mb-2"
                                    :editable="false"
                                    :clearable="false"
                                    :format="'YYYY'"
                                    default-panel="year"
                                    type="year"
                                    :lang="langPicker" 
                                    v-model="anioPeriodo"
                                    :confirm="false"
                                    :disabled-date="deshabilitarPeriodos"
                                    @change="selectRangoAnio"
                                    v-tippy="{ 
                                        placement: 'top',
                                        arrow: true, 
                                        arrowType: 'round', 
                                        animation:'fade',
                                        theme: 'google',
                                        followCursor : true,
                                        content: (empSelected != null)?'Seleccionar periodo de consulta':'Seleccione una empresa para ver periodos'
                                    }">
                                </date-picker>
                                
                                <!-- Este es el multiselect(aniosDesde) que estaba -->
                                <!-- <multiselect 
                                    class="m-0 d-inline-block mb-2 multSelectGesto" 
                                    v-model="anioSelected"
                                    deselect-label="" 
                                    placeholder="Año" 
                                    select-label=""
                                    selectedLabel=""
                                    label="anio" 
                                    track-by="anio" 
                                    :options="aniosDesde" 
                                    :searchable="true"
                                    :disabled="empSelected == null || aniosDesde.length <= 0"
                                    @select="seleccionarAnio"
                                > 
                                </multiselect> -->
                               <!--<multiselect 
                                    class="m-0 d-inline-block mb-2" 
                                    v-model="anioSelected"
                                    deselect-label="" 
                                    placeholder="Año" 
                                    select-label=""
                                    selectedLabel=""
                                    :options="aniosProcesados" 
                                    :searchable="true"
                                    :disabled="empSelected == null"
                                    @select="seleccionarAnio"
                                >
                                </multiselect>-->
                            </CCol>
                            <CCol md="2">

                                <date-picker
                                    style="width: 100%"
                                    class="mb-2"
                                    :editable="false"
                                    :clearable="false"
                                    :format="'MMMM'"
                                    default-panel="month"
                                    type="month"
                                    :lang="langPicker"
                                    v-model="mesesPeriodo"
                                    :confirm="false"
                                    range
                                    :disabled-date="deshabilitarRangoMeses"
                                    @change="selectRangoMes"
                                    v-tippy="{ 
                                        placement: 'top',
                                        arrow: true, 
                                        arrowType: 'round', 
                                        animation:'fade',
                                        theme: 'google',
                                        followCursor : true,
                                        content: (empSelected != null)?'Seleccionar mes o meses de consulta':'Seleccione una empresa para ver periodos'
                                    }"
                                ></date-picker>

                                <!-- Multiselect mes -->
                                <!-- <multiselect class="m-0 d-inline-block mb-2 multSelectGesto" 
                                    v-model="mesDesdeSelected"
                                    deselect-label="" 
                                    placeholder="Desde" 
                                    select-label=""
                                    selectedLabel=""
                                    label="nombre" 
                                    track-by="valor" 
                                    :options="mesesDesde" 
                                    :searchable="true"
                                    :disabled="empSelected == null || aniosDesde.length <= 0"
                                    @select="seleccionarMesDesde"
                                >
                                </multiselect> -->
                            </CCol>
                            <!-- <CCol md="2">
                                <multiselect class="m-0 d-inline-block mb-2 multSelectGesto" 
                                    v-model="mesHastaSelected"
                                    deselect-label="" 
                                    placeholder="Hasta" 
                                    select-label=""
                                    selectedLabel=""
                                    label="nombre" 
                                    track-by="valor" 
                                    :options="mesesHasta" 
                                    :searchable="true"
                                    :disabled="empSelected == null || aniosDesde.length <= 0"
                                    @select="seleccionarMesHasta"
                                >
                                </multiselect>
                            </CCol> -->
                            
                            <CCol md="2" v-show="comparativo" >

                                <date-picker
                                    style="width: 100%"
                                    :editable="false"
                                    :clearable="false"
                                    :format="'YYYY'"
                                    default-panel="year"
                                    type="year"
                                    :lang="langPicker" 
                                    v-model="anioComparar"
                                    :confirm="false"
                                    :disabled-date="deshabilitarPeriodos2"
                                    @change="selectRangoAnioComparar"
                                    v-tippy="{ 
                                        placement: 'top',
                                        arrow: true, 
                                        arrowType: 'round', 
                                        animation:'fade',
                                        theme: 'google',
                                        followCursor : true,
                                        content: (empSelected != null)?`Seleccionar Año a comparar contra ${(this.anioSelected!=null)?this.anioSelected.anio:''}`:'Seleccione una empresa para ver periodos'
                                    }">
                                </date-picker>

                                <!-- <multiselect class="m-0 d-inline-block mb-2 multSelectGesto"
                                    v-show="comparativo==true"  
                                    v-model="anio2Selected"
                                    deselect-label="" 
                                    placeholder="Año 2" 
                                    select-label=""
                                    selectedLabel=""
                                    label="anio" 
                                    track-by="anio" 
                                    :options="aniosHasta" 
                                    :searchable="true"
                                    :disabled="empSelected == null || aniosDesde.length <= 0"
                                    @select="seleccionarAnioHasta"
                                >
                                </multiselect> -->
                            </CCol>
                            <CCol md="3">
                                <i class="pi pi-info-circle"
                                    style="padding-right: 5px"
                                    v-show="!habilitarSwitch"
                                    content="¡No se puede comparar solo un año!"
                                    v-tippy="{
                                        placement:'top',
                                        arrow: 'true',
                                        arrowType: 'round', 
                                        animation:'fade',
                                        theme: 'google',
                                        followCursor : true,
                                    }"></i>
                                <CSwitch
                                    width="150px"
                                    class="mt-1 mx-1 align-middle mb-2 switchGesto"
                                    shape="pill"
                                    variant="outline"
                                    :disabled="!habilitarSwitch"
                                    v-bind="{labelOn: 'Si',labelOff: 'No'}"
                                    :checked="comparativo"
                                    @update:checked="comparativo = !comparativo; cambiarComparativo(comparativo)"
                                /> Comparativo
                            </CCol>
                        </CRow>
                        <CRow>                            
                            <CCol md="12">

                                <CButton
                                    size="sm"
                                    v-show="mesDesdeSelected != null && mesHastaSelected != null && anioSelected != null && empSelected != null && ((!comparativo && anio2Selected == null) || (comparativo && anio2Selected != null)) && estadoResultado.length >0"
                                    variant="ghost"
                                    class="btnPrincipalVapp mb-1 mr-1"
                                    @click="verModalDocumentos = true"
                                    :disabled="isLoadingDocumento"
                                    v-c-tooltip.hover="{content: 'Generar Documento', placement: 'over'}">
                                        Generar Documento
                                </CButton>
                            </CCol>
                        </CRow>
                        
                        <CRow>
                            <CCol col="12">
                                <a-table
                                    row-key="codigo"
                                    :columns="columnasEstadoResultado" 
                                    :data-source="estadoResultado"
                                    :pagination="{'pageSize': totalPagina}"
                                    :scroll="{ y: 400 }"
                                    :loading="isLoadingEstadoResultados"
                                    class="components-table-demo-nested mt-3"
                                    size="small" >
                                        <span slot="codigo" slot-scope="er">
                                            {{er.codigo}}
                                        </span>
                                        <span slot="descripcion" slot-scope="er">
                                            {{er.descripcion}}
                                        </span>
                                        <span slot="saldo" slot-scope="er">
                                            {{er.saldo | currency}}
                                        </span>
                                        <span slot="saldoAnio2" slot-scope="er">
                                            {{er.saldoAnio2 | currency}}
                                        </span>
                                        <span slot="analisisVert" slot-scope="er">
                                            {{er.analisisVert | currency(configPorcentaje)}}
                                        </span>
                                        <span slot="analisisHor" slot-scope="er">
                                            {{er.analisisHor | currency(configPorcentaje)}}
                                        </span>
                                </a-table>
                            </CCol>
                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
        
        <!-- Modal Generar Documentos -->
        
        <ModalGeneracionDocumento 
            :verModalDocumentos="verModalDocumentos"
            :documentoGenerado="documentoGenerado"
            :docSeleccionado="docSeleccionado"  
            :isLoadingDocumento="isLoadingDocumento"
            @generarDocumento="generarDocumento"
            @cerrarModal="cerrarModal" />
    </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<script>
    
    import cons from '@/const'
    import axios from "axios"

    //import Editor from "./Editor"
    //import EditorXls from "./EditorExcel"

    import Multiselect from 'vue-multiselect'

    import VueModal from '@kouts/vue-modal';
    import '@kouts/vue-modal/dist/vue-modal.css';
    
    import { freeSet } from '@coreui/icons'

    import moment from 'moment'
    import { format, formatDistance, formatRelative, subDays } from 'date-fns'
    import es from 'date-fns/locale/es'
    window.locale = 'es'
    
    import ActualizarEmpresas from "@/views/utils/ActualizarEmpresas";

    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    
    import ModalGeneracionDocumento from "@/views/contabilidad/componentesGeneral/ModalGeneracionDocumento";
    

    export default {
        name: 'EstadoResultados',
        freeSet,
        components: {
            Multiselect,
            'Modal': VueModal,
            ActualizarEmpresas,
            DatePicker,
            ModalGeneracionDocumento,
            //Editor,
            //EditorXls,

            //DocumentEditor: [Toolbar]            
        },
        data () {
            return {
                
                urlBase: cons.port+"://" + cons.ipServer,
                
                tokenLogin: JSON.parse(this.$cookie.get('userLogginToken')).tokenUsuario,
                tipoUserAdmin: JSON.parse(this.$cookie.get('userLogginToken')).tipoUsuario,
                idCliente: JSON.parse(this.$cookie.get('userLogginToken')).idCliente,
                
                regMail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,

                configPorcentaje: {
                    symbol: '%',
                    thousandsSeparator: '.',
                    fractionCount: 2,
                    fractionSeparator: ',',
                    symbolPosition: 'back',
                    symbolSpacing: false,
                    avoidEmptyDecimals: undefined,
                },

                selectPeriodoActual: false,

                rqstActualizarEmpresas: null,
                isActualizandoEmpresas: false,
                classActualizar: "",
                isActualizandoEmpresas: false,
                textoBtnActualizarEmpresas: "Actualizar Empresas",
                mensajesActualizacion: [],
                mostrarMensajes: false,

                ocultarCeros: true,
               

                //meses: ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"],
                aniosDesde: [],
                aniosHasta: [],
                mesesDesde: [
                    {"nombre": "Enero", "valor": 1 }, 
                    {"nombre": "Febrero", "valor": 2}, 
                    {"nombre": "Marzo", "valor": 3}, 
                    {"nombre": "Abril", "valor": 4}, 
                    {"nombre": "Mayo", "valor": 5}, 
                    {"nombre": "Junio", "valor": 6}, 
                    {"nombre": "Julio", "valor": 7}, 
                    {"nombre": "Agosto", "valor": 8}, 
                    {"nombre": "Septiembre", "valor": 9}, 
                    {"nombre": "Octubre", "valor": 10}, 
                    {"nombre": "Noviembre", "valor": 11}, 
                    {"nombre": "Diciembre", "valor": 12}
                ],
                mesesHasta: [
                    {"nombre": "Enero", "valor": 1, $isDisabled: false}, 
                    {"nombre": "Febrero", "valor": 2, $isDisabled: false}, 
                    {"nombre": "Marzo", "valor": 3, $isDisabled: false}, 
                    {"nombre": "Abril", "valor": 4, $isDisabled: false}, 
                    {"nombre": "Mayo", "valor": 5, $isDisabled: false}, 
                    {"nombre": "Junio", "valor": 6, $isDisabled: false}, 
                    {"nombre": "Julio", "valor": 7, $isDisabled: false}, 
                    {"nombre": "Agosto", "valor": 8, $isDisabled: false}, 
                    {"nombre": "Septiembre", "valor": 9, $isDisabled: false}, 
                    {"nombre": "Octubre", "valor": 10, $isDisabled: false}, 
                    {"nombre": "Noviembre", "valor": 11, $isDisabled: false}, 
                    {"nombre": "Diciembre", "valor": 12, $isDisabled: false}
                ],

                mesDesdeSelected: null,
                mesHastaSelected: null,
                anioSelected: null,
                anio2Selected: null,

                empresasInfo: [],

                empSelected: null,
                totalPagina: 20,

                comparativo: false,
                
                isLoadingEmpresasInfo: false,
                isLoadingEstadoResultados: false,

                columnasEstadoResultado: [
                    { title: 'Código', scopedSlots: { customRender: 'codigo' }, width: '33%', align: 'left', ellipsis: true},
                    { title: 'Descripción', scopedSlots:{ customRender: 'descripcion' }, width: '33%', align: 'right', ellipsis: true},
                    { title: 'Saldo', scopedSlots: { customRender: 'saldo' }, width: '33%', align: 'right', ellipsis: false}
                ],
                estadoResultado: [],


                /* Variables Modal*/

                docSeleccionado: {
                    "link": "",
                    "nombre": "",
                    "linkView": ""
                },

                verModalDocumentos: false,

                generarConFirmas: false,
                generarConArt100: false,

                isLoadingDocumento: false,
                documentoGenerado: false,

                habilitarSwitch: false,

                langPicker: cons.langPicker,
                anioPeriodo: null,
                anioComparar: null,
                mesesPeriodo: null,

            }
        },
        computed: {
        },
        created: function(){
            
        },
        beforeMount() {
            let cookieUsername = this.$cookie.get('userLogginToken')
            if(cookieUsername === null || cookieUsername === ""){
                this.$router.push("/pages/login");
            }


        },
        mounted(){
            this.obtenerSoloInfoEmpresas()
            
        },
        methods: {
            activarSwitch: function(){
                if (this.aniosDesde.length >= 2){
                    this.habilitarSwitch = true
                } else {
                    this.habilitarSwitch = false
                }
            },
            deshabilitarPeriodos: function(date, currentValue){
                let anio = format(date, "yyyy", {locale: es})
                let perNoEncontrado = true
                if(this.comparativo && this.anio2Selected != null){
                    let anioEncontrado = this.aniosDesde.find(periodo => periodo.anio == anio)
                    if (anioEncontrado !== undefined) {
                        if(this.anio2Selected.anio != anio){
                            perNoEncontrado = false
                        }
                    }
                }else{
                    let anioEncontrado = this.aniosDesde.find(periodo => periodo.anio == anio)
                    if (anioEncontrado !== undefined) {
                        perNoEncontrado = false
                    }
                }
                return perNoEncontrado

            },
            deshabilitarPeriodos2: function(date, currentValue){
                let anio = format(date, "yyyy", {locale: es})
                let perNoEncontrado = true
                if(this.aniosHasta !== null){
                    let anioEncontrado = this.aniosHasta.find(periodo => periodo.anio == anio)
                    if (anioEncontrado !== undefined && anio != this.anioSelected.anio) {
                        perNoEncontrado = false
                    }
                }
                return perNoEncontrado
            },
            selectRangoAnio: function(){
                //this.anioPeriodo = new Date(primerPeriodo.anio, 1, 1)
                if(this.mesesPeriodo != null){
                    if(this.comparativo && this.anioSelected != null && this.anio2Selected != null){
                        if(this.anio2Selected.anio == format(this.anioPeriodo, "yyyy", {locale: es})){
                            this.anioPeriodo = new Date(this.anioSelected.anio, 1, 1)
                            this.mostrarNotificaciones(2, "El año seleccionado no puede ser igual o menor al comparado")
                            return
                        }
                    }
                    this.anioSelected = this.aniosDesde.find(periodo => periodo.anio == format(this.anioPeriodo, "yyyy", {locale: es}))
                    
                    this.mesDesdeSelected = this.anioSelected.mesesDesde.find(mes => mes.valor == format(this.mesesPeriodo[0], "M", {locale: es}))
                    this.mesHastaSelected = this.anioSelected.mesesDesde.find(mes => mes.valor == format(this.mesesPeriodo[1], "M", {locale: es}))
                    
                    
                    let f1 = new Date(this.anioSelected.anio, this.mesDesdeSelected.valor-1, 1)
                    let f2 = new Date(this.anioSelected.anio, this.mesHastaSelected.valor-1, 1)
                    this.mesesPeriodo = [f1, f2] 
                    this.getER(this.anioSelected)
                }
                
            },
            selectRangoAnioComparar: function(){
                if(this.mesesPeriodo != null){
                    this.anio2Selected = this.aniosHasta.find(periodo => periodo.anio == format(this.anioComparar, "yyyy", {locale: es}))

                    console.log("this.anio2Selected", this.anio2Selected)
                    this.getER(this.anio2Selected)
                }
            },
            deshabilitarRangoMeses: function(date, currentValue){
                let mesAct = format(date, "M", {locale: es})
                let anio = format(date, "yyyy", {locale: es})
                let mesNoEncontrado = true
                if(this.anioPeriodo !== null){
                    if(format(this.anioPeriodo, "yyyy", {locale: es}) === anio){
                        let mesEncontrado = this.anioSelected.mesesDesde.find(mes => mes.valor == mesAct)
                        if(mesEncontrado != null){
                            mesNoEncontrado = false
                        }
                    }
                }
                return mesNoEncontrado
            },
            selectRangoMes: function(){
                this.mesDesdeSelected = this.anioSelected.mesesDesde.find(mes => mes.valor == format(this.mesesPeriodo[0], "M", {locale: es}))
                this.mesHastaSelected = this.anioSelected.mesesDesde.find(mes => mes.valor == format(this.mesesPeriodo[1], "M", {locale: es}))
                
                this.getER(this.anioSelected)
            },
             
            ocultarCerosProcesar: function(){
                this.ocultarCeros = !this.ocultarCeros

                if(this.comparativo){
                    if(this.anio2Selected != null)
                        this.getER(this.anio2Selected)
                }
                else{
                    this.getER(this.anioSelected)
                }

                
            },
            obtenerPeriodoEmpresa: function(){

                var url = this.urlBase + "/get_periodo_empresa_estado_resultado";
                this.aniosDesde = []
                this.aniosHasta = []
                this.mesesDesde = []
                this.mesesHasta = []


                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "idCliente": this.idCliente,
                        "idEmpresa": this.empSelected.idEmpresa
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.aniosDesde = result.data.aniosDesde
                    this.aniosHasta = result.data.aniosHasta
                    this.activarSwitch()

                    if(this.selectPeriodoActual){
                        this.seleccionarPeriodoActualCargaEmpresa()
                        
                        this.selectPeriodoActual = !this.selectPeriodoActual

                    } else{
                        
                        this.seleccionarPeriodoActualCargaEmpresa()

                        /*let primerPeriodo = this.aniosDesde[0]
                        this.anioPeriodo = new Date(primerPeriodo.anio, 1, 1)
                        this.anioSelected = primerPeriodo
                        let mesesPeriodo = primerPeriodo.mesesDesde
                        let primerMesPeriodo = mesesPeriodo[0]
                        let ultimoMesPeriodo = mesesPeriodo[mesesPeriodo.length-1]
                        
                        this.mesDesdeSelected = primerMesPeriodo
                        this.mesHastaSelected = ultimoMesPeriodo
                        
                        let f1 = new Date(primerPeriodo.anio, primerMesPeriodo.valor-1, 1)
                        let f2 = new Date(primerPeriodo.anio, ultimoMesPeriodo.valor-1, 1)
                        this.mesesPeriodo = [f1, f2] 
                        if(this.comparativo){
                            if(this.aniosHasta.length == 1 && this.aniosHasta[0].anio == this.anioSelected.anio){
                                this.mostrarNotificaciones(2, "Ups, la empresa seleccionada solo tiene un año de información para mostrar y es el mismo seleccionado")
                                this.comparativo = false
                            } else{
                                if(this.aniosHasta.length > 1){
                                    this.anio2Selected =  this.aniosHasta[1]
                                    this.anioComparar = new Date(this.aniosHasta[1].anio,1,1)
                                } else{
                                    this.anio2Selected =  this.aniosHasta[0]
                                    this.anioComparar = new Date(this.aniosHasta[0].anio,1,1)
                                }
                            }
                        }
                        this.getER(this.anioSelected)*/

                    }

                }, error => {
                    
                    this.mostrarNotificaciones(3, error.response.data.mensajeGeneral)
                    this.isLoadingEstadoResultados = false
                    this.selectPeriodoActual = false

                    this.anioPeriodo = null

                    this.mesDesdeSelected = null;
                    this.mesHastaSelected = null;
                    this.mesesPeriodo = null;
                    this.anioSelected = null;
                    this.anio2Selected = null;
                    this.estadoResultado = []
                })
                .finally(() => {
                });
            },
            obtenerSoloInfoEmpresas: function(){
                this.isLoadingEmpresasInfo = true
                var url = this.urlBase + "/get_empresas_info/CONTA";
                
                axios({
                    method: "GET", 
                    "url": url,
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    
                    this.empresasInfo = result.data;

                }, error => {
                    //let mensaje = `Problema al obtener empresas , ${error}`
                    //this.textoSinEmpresas = mensaje
                })
                .finally(() => {
                    this.isLoadingEmpresasInfo = false
                });
            },
            cambiarComparativo: function(comparativo){
                if(!comparativo){
                    
                    //this.columnasEstadoResultado.push({ title: 'Saldo Año 2', scopedSlots: { customRender: 'saldoAnio2' }, width: '15%', align: 'center', ellipsis: true})
                    //   this.columnasEstadoResultado.push({ title: 'Análisis Vertical', scopedSlots: { customRender: 'analisisVert' }, width: '15%', align: 'center', ellipsis: true})
                    //  this.columnasEstadoResultado.push({ title: 'Análisis Horizontal', scopedSlots: { customRender: 'analisisHor' }, width: '15%', align: 'center', ellipsis: true})

                        
                    var encontrado = this.columnasEstadoResultado.indexOf(this.columnasEstadoResultado.find(columna => columna.scopedSlots.customRender == 'saldoAnio2'))
                    if ( encontrado !== -1 ) {
                        this.columnasEstadoResultado.splice(encontrado, 1)
                    }
                    var encontrado = this.columnasEstadoResultado.indexOf(this.columnasEstadoResultado.find(columna => columna.scopedSlots.customRender == 'analisisVert'))
                    if ( encontrado !== -1 ) {
                        this.columnasEstadoResultado.splice(encontrado, 1)
                    }
                    var encontrado = this.columnasEstadoResultado.indexOf(this.columnasEstadoResultado.find(columna => columna.scopedSlots.customRender == 'analisisHor'))
                    if ( encontrado !== -1 ) {
                        this.columnasEstadoResultado.splice(encontrado, 1)
                    }
                }
                if(this.empSelected != null && this.mesDesdeSelected != null && this.mesHastaSelected != null){
                    if(this.comparativo){
                        if(this.anio2Selected != null)
                            this.getER(this.anio2Selected)
                    }
                    else{
                        this.getER(this.anioSelected)
                    }

                }
            },
            
            getER: function(anio){
                this.isLoadingEstadoResultados = true
                /*if(this.comparativo){
                    this.anio2Selected = anio
                } else{
                    this.anioSelected = anio
                }*/
                
                this.estadoResultado = []

                var url = this.urlBase + "/get_estado_resultado_empresa";
                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": this.idCliente,
                            "idEmpresa": this.empSelected.idEmpresa,
                            "mesDesde": this.mesDesdeSelected.nombre,
                            "mesHasta": this.mesHastaSelected.nombre,
                            "anio": this.anioSelected.anio,
                            "comparativo": this.comparativo,
                            "anio2": (this.anio2Selected!=null)?this.anio2Selected.anio:null,
                            "ocultarCeros": this.ocultarCeros
                        },
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    if(this.comparativo){
                        this.columnasEstadoResultado = [
                            { title: 'Código', scopedSlots: { customRender: 'codigo' }, width: '33%', align: 'left', ellipsis: true},
                            { title: 'Descripción', scopedSlots:{ customRender: 'descripcion' }, width: '33%', align: 'right', ellipsis: true},
                            { title: `Saldo (${this.anioSelected.anio})`, scopedSlots: { customRender: 'saldo' }, width: '33%', align: 'right', ellipsis: false},
                            { title: `Saldo (${this.anio2Selected.anio})`, scopedSlots: { customRender: 'saldoAnio2' }, width: '15%', align: 'center', ellipsis: true },
                            { title: 'Análisis Vertical', scopedSlots: { customRender: 'analisisVert' }, width: '15%', align: 'center', ellipsis: true },
                            { title: 'Análisis Horizontal', scopedSlots: { customRender: 'analisisHor' }, width: '15%', align: 'center', ellipsis: true }
                        ]
                            
                        //this.columnasEstadoResultado.push({ title: `Saldo (${this.anioSelected.anio})`, scopedSlots: { customRender: 'saldoAnio2' }, width: '15%', align: 'center', ellipsis: true})
                        //this.columnasEstadoResultado.push({ title: 'Análisis Vertical', scopedSlots: { customRender: 'analisisVert' }, width: '15%', align: 'center', ellipsis: true})
                        //this.columnasEstadoResultado.push({ title: 'Análisis Horizontal', scopedSlots: { customRender: 'analisisHor' }, width: '15%', align: 'center', ellipsis: true})
                    
                    } else{
                        this.columnasEstadoResultado = [
                            { title: 'Código', scopedSlots: { customRender: 'codigo' }, width: '33%', align: 'left', ellipsis: true},
                            { title: 'Descripción', scopedSlots:{ customRender: 'descripcion' }, width: '33%', align: 'right', ellipsis: true},
                            { title: 'Saldo', scopedSlots: { customRender: 'saldo' }, width: '33%', align: 'right', ellipsis: false}
                        ]
                    }
                    
                    this.totalPagina = result.data.length
                    this.estadoResultado = result.data;
                    this.isLoadingEstadoResultados = false
                    
                    this.selectPeriodoActual = false

                }, error => {
                    this.isLoadingEstadoResultados = false
                    this.selectPeriodoActual = false
                    this.$notification.error(
                        error.response.data.mensajeGeneral,
                        { timer: 10, position: "bottomRight" }
                    );
                });

            },
            seleccionarEmpresa: function(emp){
                this.empSelected = emp
                this.obtenerPeriodoEmpresa()
                /*if(this.mesDesdeSelected != null && this.mesHastaSelected != null && this.anioSelected != null){
                    if(this.comparativo){
                        if(this.anio2Selected != null)
                            this.getER(this.anio2Selected)
                    } else{
                        this.getER(this.anioSelected)
                    }
                }*/

            },
            seleccionarMesDesde: function(mesDesde){
                this.validarMesHasta(mesDesde)
                this.mesDesdeSelected = mesDesde
                if(this.mesHastaSelected != null){
                    if(this.mesHastaSelected.valor < mesDesde.valor){
                        this.mesHastaSelected = null
                    } else{
                        if(this.mesDesdeSelected != null && this.mesHastaSelected != null && this.anioSelected != null){
                            if(this.comparativo){
                                if(this.anio2Selected != null)
                                    this.getER(this.anio2Selected)
                            } else{
                                this.getER(this.anioSelected)
                            }
                        }
                    }
                }
            },
            seleccionarMesHasta: function(mesHasta){
                this.mesHastaSelected = mesHasta
                if(this.empSelected != null && this.mesDesdeSelected != null && this.anioSelected != null){
                    if(this.comparativo){
                        if(this.anio2Selected != null)
                            this.getER(this.anio2Selected)
                    } else{
                        this.getER(this.anioSelected)
                    }
                }
            },

            validarMesHasta: function(opcion){
                this.mesesHasta.forEach(mes =>{
                    if(mes.valor < opcion.valor){
                        mes.$isDisabled = true
                    }
                    else{
                        mes.$isDisabled = false
                    }
                })
            },
            seleccionarAnio: function(anio){
                this.validarAnioHasta(anio.anio)
                this.anioSelected = anio

                this.mesesDesde = anio.mesesDesde
                this.mesesHasta = anio.mesesHasta

                if(this.empSelected != null && this.mesDesdeSelected != null && this.mesHastaSelected != null){
                    if(this.comparativo){
                        if(this.anio2Selected != null)
                            this.getER(this.anio2Selected)
                    }
                    else{
                        this.getER(this.anioSelected)
                    }

                }
            },
            seleccionarAnioHasta: function(anio){
                this.anio2Selected = anio
                if(this.empSelected != null && this.mesDesdeSelected != null && this.mesHastaSelected != null && this.anioSelected != null){
                    if(this.comparativo){
                        if(this.anio2Selected != null)
                            this.getER(this.anio2Selected)
                    }
                    else{
                        this.getER(this.anioSelected)
                    }

                }
            },
            validarAnioHasta: function(opcion){
                this.aniosHasta.forEach(anio => {
                    if(anio.valor < opcion){
                        anio.$isDisabled = true
                    } else{
                        anio.$isDisabled = false
                    }
                })
            },
            seleccionarPeriodoActualCargaEmpresa: function(){

                const ultimoPeriodo = this.aniosDesde[this.aniosDesde.length - 1];
                this.anioSelected = ultimoPeriodo;
                this.anioPeriodo = new Date(ultimoPeriodo.anio, 1, 1)

                // Asegurar que existan meses en el periodo seleccionado
                if (!this.anioSelected.mesesDesde || this.anioSelected.mesesDesde.length === 0) {
                    this.mostrarNotificaciones(2, "No hay meses en el periodo seleccionado.");
                    return;
                }

                // Tomar el último mes
                const ultimoMes = this.anioSelected.mesesDesde[this.anioSelected.mesesDesde.length - 1];
                this.mesDesdeSelected = ultimoMes;
                this.mesHastaSelected = ultimoMes;

                // Construir las fechas en base al año y a los meses seleccionados
                const f1 = new Date(this.anioSelected.anio, this.mesDesdeSelected.valor - 1, 1);
                const f2 = new Date(this.anioSelected.anio, this.mesHastaSelected.valor - 1, 1);
                this.mesesPeriodo = [f1, f2];

                // Invertir valor booleano (si corresponde a tu lógica)
                this.selectPeriodoActual = !this.selectPeriodoActual;

                // Manejo del caso comparativo
                if (this.comparativo) {
                    // Verificamos que haya datos en aniosHasta
                    if (!this.aniosHasta || this.aniosHasta.length === 0) {
                    this.mostrarNotificaciones(2,"No hay datos en aniosHasta para comparativo.");
                    } else {
                    // Tomamos el último año disponible también
                    this.anio2Selected = this.aniosHasta[this.aniosHasta.length - 1];
                    this.anioComparar = new Date(this.anio2Selected.anio, 1, 1);
                    }
                }

                // Logs para depuración
                console.log("this.anioSelected", this.anioSelected);
                console.log("this.mesDesdeSelected", this.mesDesdeSelected);
                console.log("this.mesHastaSelected", this.mesHastaSelected);
                console.log("this.mesesPeriodo", this.mesesPeriodo);
                this.getER(this.anioSelected)
                /*
                this.mesDesdeSelected = null;
                this.mesHastaSelected = null;
                this.mesesPeriodo = null;
                this.anioSelected = null;
                this.anio2Selected = null;

                let fechaActual = new Date();
                // Obtener el número del mes actual (0-11)
                let mesActualNumero = fechaActual.getMonth()+1;
                let anioActual = fechaActual.getFullYear();
                let primerPeriodo = this.aniosDesde[0]
                let mesesPeriodo = primerPeriodo.mesesDesde
                let primerMesPeriodo = mesesPeriodo[0]
                let ultimoMesPeriodo = mesesPeriodo[mesesPeriodo.length-1]
                this.anioSelected = primerPeriodo
                this.mesDesdeSelected = this.anioSelected.mesesDesde.find(mes => mes.valor == mesActualNumero)
                this.mesHastaSelected = this.anioSelected.mesesDesde.find(mes => mes.valor == mesActualNumero)

                this.anioPeriodo = new Date(primerPeriodo.anio, 1, 1)
                let f1 = new Date(primerPeriodo.anio, this.mesDesdeSelected.valor-1, 1)
                let f2 = new Date(primerPeriodo.anio, this.mesHastaSelected.valor-1, 1)
                this.mesesPeriodo = [f1, f2]
                this.selectPeriodoActual = !this.selectPeriodoActual
                
                if(this.comparativo){
                    this.anio2Selected =  this.aniosHasta[1]
                    this.anioComparar = new Date(this.aniosHasta[1].anio,1,1)
                }
                console.log("this.anioSelected", this.anioSelected)
                console.log("this.mesDesdeSelected", this.mesDesdeSelected)
                console.log("this.mesHastaSelected", this.mesHastaSelected)
                this.getER(this.anioSelected)*/
                
            },
            seleccionarPeriodoActual: function(){
                console.log("entros")
                console.log("this.empSelected", this.empSelected)
                if (this.empSelected != null){
                    this.seleccionarPeriodoActualCargaEmpresa()
                } else{
                    this.seleccionarEmpresa(this.empresasInfo[0])
                }
                //this.selectPeriodoActual = !this.selectPeriodoActual
                //this.seleccionarEmpresa(this.empresasInfo[0])
            },

            customLabelEmp (empresa) {
                return `(${empresa.codEmpresa}) ${empresa.nombreEmpresa}`;
            },

            /* Metodos Modal */
            cerrarModal: function () {
                this.verDocumento = false;
                this.verModalDocumentos = false;
            },
            
            generarDocumento: function(event){
                this.docSeleccionado = {
                    "link": "",
                    "nombre": "",
                    "linkView": ""
                }
                if(event.pdf){
                    this.generarConArt100 = event.art100
                    this.generarConFirmas = event.firmas
                    this.generarPdf()
                }
                else if(event.csv){
                    this.generarCsv()
                }

            },
            
            generarCsv: function(){
                this.isLoadingDocumento = true
                this.documentoGenerado = false

                var url = this.urlBase + "/generar_csv_estado_resultado";

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": this.idCliente,
                            "idEmpresa": this.empSelected.idEmpresa,
                            "mesDesde": this.mesDesdeSelected.nombre,
                            "mesHasta": this.mesHastaSelected.nombre,
                            "anio": this.anioSelected.anio,
                            "comparativo": this.comparativo,
                            "anio2": (this.anio2Selected!=null)?this.anio2Selected.anio:null,
                            "agregarArt100": this.generarConArt100,
                            "agregarFirmas": this.generarConFirmas,
                            "ocultarCeros": this.ocultarCeros
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.isLoadingDocumento = false
                    

                    var link = result.data.archivoGenerado.link
                    
                    /*var fileLink = document.createElement("a");
                    fileLink.href = link;
                    fileLink.setAttribute("download", result.data.archivoGenerado.nombre);
                    document.body.appendChild(fileLink);
                    fileLink.click();*/
                    this.docSeleccionado = {
                        "link": result.data.archivoGenerado.link,
                        "nombre": result.data.archivoGenerado.nombre,
                        "linkView": result.data.archivoGenerado.linkView.replace('view', 'preview'),
                    }
                    this.pdfGenerado = true
                    this.documentoGenerado = true

                    this.$notification.success(
                        result.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                    );

                }, error => {
                    
                    this.documentoGenerado = false
                    this.isLoadingDocumento = false
                    
                    this.$notification.error(
                        error.response.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                    );
                });
            },

            generarPdf: function(){
                this.isLoadingDocumento = true
                this.documentoGenerado = false


                var url = this.urlBase + "/generar_pdf_estado_resultado";

                axios({
                    method: "POST", 
                    "url": url,
                    "data": {
                        "info": {
                            "idCliente": this.idCliente,
                            "idEmpresa": this.empSelected.idEmpresa,
                            "mesDesde": this.mesDesdeSelected.nombre,
                            "mesHasta": this.mesHastaSelected.nombre,
                            "anio": this.anioSelected.anio,
                            "comparativo": this.comparativo,
                            "anio2": (this.anio2Selected!=null)?this.anio2Selected.anio:null,
                            "agregarArt100": this.generarConArt100,
                            "agregarFirmas": this.generarConFirmas,
                            "ocultarCeros": this.ocultarCeros
                        }
                    },
                    "headers": {
                        'Authorization': `${this.tokenLogin}`
                    }
                }).then(result => {
                    this.isLoadingDocumento = false
                    

                     /*var link = result.data.archivoGenerado.link
                    
                   var fileLink = document.createElement("a");
                    fileLink.href = link;
                    fileLink.setAttribute("download", result.data.archivoGenerado.nombre);
                    document.body.appendChild(fileLink);
                    fileLink.click();*/
                    
                    this.docSeleccionado = {
                        "link": result.data.archivoGenerado.link,
                        "nombre": result.data.archivoGenerado.nombre,
                        "linkView": result.data.archivoGenerado.linkView.replace('view', 'preview'),
                    }
                    this.pdfGenerado = true
                    this.documentoGenerado = true

                    this.$notification.success(
                        result.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                    );

                }, error => {
                    this.documentoGenerado = false
                    this.isLoadingDocumento = false

                    this.$notification.error(
                        error.response.data.mensaje,
                        { timer: 10, position: "bottomRight" }
                    );
                });
            },
            /**Fin Metodos Modal */

        }
        
    }
</script>

<style>
    .imgr{
        -webkit-animation: 3s rotate linear infinite;
        animation: 3s rotate  linear infinite;
        -webkit-transform-origin: 50% 50%;
        transform-origin: 50% 50%;
    }
    .search-box2{
        position: absolute;
        left: 60px;
        transform: translate(0, -50%);
        background: #2c3441;
        height: 40px;
        border-radius: 40px;
    }
    .search-box2:hover > input{
        width: 200px;
        padding: 0 10px;
    }
    .icon2{
        color: #21dfcd;
        float: right;
        width: 40px;
        font-size: 1.3rem;
        height: 40px;
        border-radius: 50%;
        background: #2f3640;
        display: flex;
        justify-content: center;
        align-items: center;
        transition: 0.4s;
        cursor: pointer;
        text-decoration: none;
    }
    .icon2:hover{
        transform: rotate(360deg) scale(0.8);
    }
    input{
        width: 0;
        border: none;
        outline: none;
        padding: 0;
        background: none;
        font-size: 1.1rem;
        transition: 0.5s ease;
        line-height: 40px;
        color: #fff;
    }
    

    .switchGesto .c-switch-input:checked + .c-switch-slider {
        border-color: #29235C;
    }
    .switchGesto .c-switch-input:checked + .c-switch-slider::before {
        background-color: #29235C;
        border-color: #29235C;
    }
    .switchGesto .c-switch-input:checked + .c-switch-slider::after {
        color: #29235C;
    }
    .switchGesto .c-switch-slider {
        border-color: #29235C;
    }
    .switchGesto .c-switch-slider::before {
        background-color: #29235C;
        border-color: #29235C;
    }
    .switchGesto .c-switch-slider::after {
        color: #461A3B;

    }
    .center-content {
        display: flex;
        justify-content: center; /* Centra horizontalmente */
        align-items: center; /* Centra verticalmente */
        height: 100%; /* Asegúrate de que haya espacio suficiente */
    }

</style>